export default {
      id: "panels-usage",
      viewBox: "0 0 39 27",
      url: __webpack_public_path__ + "img/icons.svg#panels",
      toString: function () {
        return this.url;
      }
    }